import React from "react";
import PropTypes from "prop-types";
import TextInput from "@cx/ui/TextInput";
import { MAX_SETTING_LENGTH } from "./SettingDisplayTypes";

export default class SensitiveSettingType extends React.Component {
  static propTypes = {
    setting: PropTypes.object,
    settingName: PropTypes.string,
    settingType: PropTypes.string,
    toggleClearSettings: PropTypes.func,
    updateSetting: PropTypes.func
  };

  state = {
    value: "",
    isDisabled: true,
    setting: this.props.setting,
    settingName: this.props.settingName,
    toggleSetting: true
  };

  updateSetting = event => {
    this.props.updateSetting(event);
  };

  render() {
    const { displayName } = this.props.setting,
      readOnly = this.props.setting.value.indexOf("*") !== -1;

    return (
      <div>
        {" "}
        <TextInput
          readOnly={readOnly}
          htmlId={"SettingType" + this.props.setting.name}
          label={displayName}
          name={this.props.setting.name}
          maxLength={MAX_SETTING_LENGTH}
          onChange={this.updateSetting}
          value={this.props.setting.value}
          getError={(_label, value) =>
            value && value.length >= MAX_SETTING_LENGTH
              ? `Value has reached the ${MAX_SETTING_LENGTH} character limit. Exceeding characters will be truncated.`
              : ""
          }
        />
      </div>
    );
  }
}
